export default (node) => {
  /**
   * Data + elements
   */
  /**
   * Functions
   */
  const storefrontUrl = klevuAccess.storefrontUrl;
  const accessToken = klevuAccess.storefrontAccessToken;

    const METAOBJECTS_QUERY = `
      query GetBedStyleMetaobjects($type: String!, $pageSize: Int!, $cursor: String) {
        metaobjects(type: $type, first: $pageSize, after: $cursor, sortKey: "updated_at") {
          edges {
            cursor
            node {
              id
              handle
              type
              updatedAt
              fields {
                key
                value
                reference {
                  ... on MediaImage {
                    id
                    image { url }
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;

    async function fetchAllBedStyles(pageSize = 50) {
      let cursor = null;
      const all = [];

      while (true) {
        const res = await fetch(storefrontUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": accessToken,
          },
          body: JSON.stringify({
            query: METAOBJECTS_QUERY,
            variables: { type: "bed_style", pageSize, cursor },
          }),
        });

        const { data, errors } = await res.json();
        if (errors) throw new Error(JSON.stringify(errors, null, 2));

        const { edges, pageInfo } = data.metaobjects;
        all.push(...edges.map(e => e.node));

        if (!pageInfo.hasNextPage) break;
        cursor = pageInfo.endCursor;
      }

      return all;
    }

  /**
   * Init
   */
  const init = async () => {
    // check if the metaobjects data are already in session storage
    const checkMetaobjectsData = JSON.parse(sessionStorage.getItem('metaobjectsData'));
    if (!checkMetaobjectsData) {
      const metaobjectsData = await fetchAllBedStyles();
      // clean data to get only the key: image and key: label
      const cleanData = metaobjectsData.map((metaobject) => {
        return {
          image: metaobject.fields.find((field) => field.key === 'image')?.reference?.image?.url ?? null,
          label: metaobject.fields.find((field) => field.key === 'label')?.value ?? null,
          id: metaobject.id,
        };
      });
      // save in a variable for session storage
      sessionStorage.setItem('metaobjectsData', JSON.stringify(cleanData));
    }
  };

  init();
};
